// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   AdminSystemPage.responsive.css
   Responsive Stylesheet for System & Usage Command Center
   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED
   ========================================================================== */

/* ==========================================================================
   IPAD & TABLETS (max-width: 1024px)
   ========================================================================== */
@media (max-width: 1024px) {
  .mgadmin-page {
    width: 100%;
    max-width: 100vw;
    padding: 14px 18px 40px !important;
    overflow-x: hidden;
  }

  .mgadmin-hero {
    grid-template-columns: 1fr !important;
    gap: 22px !important;
    padding: 24px !important;
  }

  .mgadmin-hero h1 {
    font-size: clamp(28px, 4.2vw, 36px) !important;
    line-height: 1.1 !important;
  }

  .mgadmin-hero-panel {
    max-width: 100% !important;
    padding: 20px !important;
  }

  .mgadmin-stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 12px !important;
    margin: 18px 0 !important;
  }

  .mgadmin-grid {
    grid-template-columns: 1fr !important;
    gap: 18px !important;
  }

  .mgadmin-table-wrap {
    width: 100% !important;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch !important;
    border-radius: 14px !important;
  }
}

/* ==========================================================================
   MOBILE PHONES (max-width: 768px)
   ========================================================================== */
@media (max-width: 768px) {
  .mgadmin-page {
    padding: 10px 10px 30px !important;
  }

  .mgadmin-hero {
    padding: 16px 14px !important;
    gap: 14px !important;
    border-radius: 16px !important;
  }

  .mgadmin-hero h1 {
    font-size: 24px !important;
    line-height: 1.15 !important;
  }

  .mgadmin-hero p {
    font-size: 13px !important;
    line-height: 1.5 !important;
    margin: 10px 0 14px !important;
  }

  .mgadmin-actions {
    display: flex !important;
    gap: 8px !important;
    flex-wrap: wrap !important;
    width: 100% !important;
  }

  .mgadmin-actions .mgadmin-btn {
    flex: 1 1 auto !important;
    min-height: 40px !important;
    font-size: 12.5px !important;
  }

  .mgadmin-hero-panel {
    padding: 14px !important;
    border-radius: 14px !important;
  }

  /* Stats grid */
  .mgadmin-stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 8px !important;
    margin: 14px 0 !important;
  }

  .mgadmin-stat-card {
    padding: 12px 10px !important;
    border-radius: 12px !important;
  }

  .mgadmin-stat-card strong {
    font-size: 18px !important;
  }

  .mgadmin-card {
    padding: 14px !important;
    border-radius: 14px !important;
    margin-bottom: 14px !important;
  }

  .mgadmin-card h2 {
    font-size: 17px !important;
  }

  .mgadmin-table-wrap {
    width: 100% !important;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch !important;
    border-radius: 12px !important;
  }

  .mgadmin-table {
    min-width: 580px !important;
  }

  .mgadmin-log-box {
    max-height: 340px !important;
    font-size: 11px !important;
    padding: 12px 10px !important;
    border-radius: 12px !important;
    overflow-x: auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AdminSystemPage.responsive.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;;AAE/E;;+EAE+E;AAC/E;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,8CAA8C;IAC9C,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;IACE,2DAA2D;IAC3D,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,qCAAqC;IACrC,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,4CAA4C;IAC5C,8BAA8B;EAChC;AACF;;AAEA;;+EAE+E;AAC/E;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA,eAAe;EACf;IACE,2DAA2D;IAC3D,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,4CAA4C;IAC5C,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;IAC7B,8BAA8B;IAC9B,2BAA2B;EAC7B;AACF","sourcesContent":["/* ==========================================================================\n   AdminSystemPage.responsive.css\n   Responsive Stylesheet for System & Usage Command Center\n   DESKTOP / LAPTOP (>= 1025px) IS 100% UNTOUCHED\n   ========================================================================== */\n\n/* ==========================================================================\n   IPAD & TABLETS (max-width: 1024px)\n   ========================================================================== */\n@media (max-width: 1024px) {\n  .mgadmin-page {\n    width: 100%;\n    max-width: 100vw;\n    padding: 14px 18px 40px !important;\n    overflow-x: hidden;\n  }\n\n  .mgadmin-hero {\n    grid-template-columns: 1fr !important;\n    gap: 22px !important;\n    padding: 24px !important;\n  }\n\n  .mgadmin-hero h1 {\n    font-size: clamp(28px, 4.2vw, 36px) !important;\n    line-height: 1.1 !important;\n  }\n\n  .mgadmin-hero-panel {\n    max-width: 100% !important;\n    padding: 20px !important;\n  }\n\n  .mgadmin-stats-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n    gap: 12px !important;\n    margin: 18px 0 !important;\n  }\n\n  .mgadmin-grid {\n    grid-template-columns: 1fr !important;\n    gap: 18px !important;\n  }\n\n  .mgadmin-table-wrap {\n    width: 100% !important;\n    overflow-x: auto !important;\n    -webkit-overflow-scrolling: touch !important;\n    border-radius: 14px !important;\n  }\n}\n\n/* ==========================================================================\n   MOBILE PHONES (max-width: 768px)\n   ========================================================================== */\n@media (max-width: 768px) {\n  .mgadmin-page {\n    padding: 10px 10px 30px !important;\n  }\n\n  .mgadmin-hero {\n    padding: 16px 14px !important;\n    gap: 14px !important;\n    border-radius: 16px !important;\n  }\n\n  .mgadmin-hero h1 {\n    font-size: 24px !important;\n    line-height: 1.15 !important;\n  }\n\n  .mgadmin-hero p {\n    font-size: 13px !important;\n    line-height: 1.5 !important;\n    margin: 10px 0 14px !important;\n  }\n\n  .mgadmin-actions {\n    display: flex !important;\n    gap: 8px !important;\n    flex-wrap: wrap !important;\n    width: 100% !important;\n  }\n\n  .mgadmin-actions .mgadmin-btn {\n    flex: 1 1 auto !important;\n    min-height: 40px !important;\n    font-size: 12.5px !important;\n  }\n\n  .mgadmin-hero-panel {\n    padding: 14px !important;\n    border-radius: 14px !important;\n  }\n\n  /* Stats grid */\n  .mgadmin-stats-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n    gap: 8px !important;\n    margin: 14px 0 !important;\n  }\n\n  .mgadmin-stat-card {\n    padding: 12px 10px !important;\n    border-radius: 12px !important;\n  }\n\n  .mgadmin-stat-card strong {\n    font-size: 18px !important;\n  }\n\n  .mgadmin-card {\n    padding: 14px !important;\n    border-radius: 14px !important;\n    margin-bottom: 14px !important;\n  }\n\n  .mgadmin-card h2 {\n    font-size: 17px !important;\n  }\n\n  .mgadmin-table-wrap {\n    width: 100% !important;\n    overflow-x: auto !important;\n    -webkit-overflow-scrolling: touch !important;\n    border-radius: 12px !important;\n  }\n\n  .mgadmin-table {\n    min-width: 580px !important;\n  }\n\n  .mgadmin-log-box {\n    max-height: 340px !important;\n    font-size: 11px !important;\n    padding: 12px 10px !important;\n    border-radius: 12px !important;\n    overflow-x: auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
